import { ChevronDown } from 'lucide-react'

import { Button } from '@/common/ui/button'
import { Badge } from '@/common/ui/badge'

interface ScrollToBottomButtonProps {
	newMessageCount: number
	messagePreview?: string
	onClick: () => void
}

export function ScrollToBottomButton({
	newMessageCount,
	messagePreview,
	onClick,
}: ScrollToBottomButtonProps) {
	return (
		<div className="absolute bottom-4 left-1/2 -translate-x-1/2">
			<Button
				variant="secondary"
				size="sm"
				className="flex max-w-[280px] gap-2 rounded-full shadow-lg"
				onClick={onClick}
			>
				<ChevronDown className="h-4 w-4 shrink-0" />
				{newMessageCount > 0 ? (
					<span className="flex items-center gap-2 overflow-hidden">
						<Badge
							variant="destructive"
							className="h-5 min-w-5 shrink-0 px-1.5"
						>
							{newMessageCount}
						</Badge>
						{messagePreview ? (
							<span className="truncate text-xs">{messagePreview}</span>
						) : (
							'ข้อความใหม่'
						)}
					</span>
				) : (
					'เลื่อนลงล่าง'
				)}
			</Button>
		</div>
	)
}
